"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createClient = createClient;
var _routing = require("../../routing.cjs");
function createClient(api) {
  async function signup(payload) {
    const url = `${_routing.routing.billing}/signup`;
    return api.post(url, {
      payload
    });
  }
  async function getPlan() {
    const {
      plan
    } = await api.get(`${_routing.routing.billing}/plan`);
    return plan;
  }
  return {
    signup,
    getPlan
  };
}